export default __webpack_public_path__ + "static/media/phone.abc6a37b.svg";